/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Cancel_ButtonInputs */

const en_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_video_export_cancel_button = /** @type {(inputs: Video_Export_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Video_Export_Cancel_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_cancel_button = /** @type {((inputs?: Video_Export_Cancel_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Cancel_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_cancel_button(inputs)
	if (locale === "de") return de_video_export_cancel_button(inputs)
	if (locale === "it") return it_video_export_cancel_button(inputs)
	if (locale === "ru") return ru_video_export_cancel_button(inputs)
	if (locale === "es") return es_video_export_cancel_button(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_cancel_button(inputs)
	if (locale === "ja") return ja_video_export_cancel_button(inputs)
	if (locale === "hi") return hi_video_export_cancel_button(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_cancel_button(inputs)
	return en_video_export_cancel_button(inputs)
});